import slide1Src from "../../assets/merch/MNSMCHERRIESSATINJACKET_600x600.png";
import slide2Src from "../../assets/merch/MNSMBLUEFLAMESATINJACKET_600x600.png";
import slide3Src from "../../assets/merch/MNSMWHITELIGHTNIN_SATINJACKET_600x600.png";
import slide4Src from "../../assets/merch/MINCLUSIONJARSSHOPPERTOTE2_600x600.png";
import slide5Src from "../../assets/merch/MINCLUSIONJARSCOTTONPOUCH_600x600.png";
import slide6Src from "../../assets/merch/MNSMWHITELIGHTNIN_CIRCLETEE_600x600.png";
import slide7Src from "../../assets/merch/OSJRTMOONSHINECLUBFOAMTRUCKERHAT-BLACK_600x600.png";
import slide8Src from "../../assets/merch/MNSMMOONSHINECLUBTEE_600x600.png";
import slide9Src from "../../assets/merch/MBORNTOSHINEHAT-NEONPINK_600x600.png";
import slide10Src from "../../assets/merch/MTHISISPROBABLYMOONSHINECANVASFLASK_600x600.png";
import slide11Src from "../../assets/merch/WMSMDRINKINWATERMELONTEE_600x600.png";

export const slides = [
  {
    id: 1,
    label: "CHERRIES SATIN JACKET",
    imageSrc: slide1Src,
    link: "https://olesmoky.com/collections/merchandise/products/mns-m-white-lightnin-satin-jacket-copy",
  },
  {
    id: 2,
    label: "BLUE FLAME SATIN JACKET",
    imageSrc: slide2Src,
    link: "https://olesmoky.com/collections/merchandise/products/mns-m-blue-flame-satin-jacket",
  },
  {
    id: 3,
    label: "WHITE LIGHTNIN' SATIN JACKET",
    imageSrc: slide3Src,
    link: "https://olesmoky.com/collections/merchandise/products/mns-m-white-lightnin-satin-jacket",
  },
  {
    id: 4,
    label: "INCLUSION JARS SHOPPER TOTE",
    imageSrc: slide4Src,
    link: "https://olesmoky.com/collections/merchandise/products/inclusion-jars-shopper-tote",
  },
  {
    id: 5,
    label: "INCLUSION JARS COTTON POUCH",
    imageSrc: slide5Src,
    link: "https://olesmoky.com/collections/merchandise/products/inclusion-jars-cotton-pouch",
  },
  {
    id: 6,
    label: "WHITE LIGHTNIN' CIRCLE TEE",
    imageSrc: slide6Src,
    link: "https://olesmoky.com/collections/merchandise/products/white-lightnin-circle-tee",
  },
  {
    id: 7,
    label: "MOONSHINE CLUB FOAM TRUCKER HAT - BLACK",
    imageSrc: slide7Src,
    link: "https://olesmoky.com/collections/merchandise/products/moonshine-club-foam-trucker-hat-black",
  },
  {
    id: 8,
    label: "MOONSHINE CLUB TEE",
    imageSrc: slide8Src,
    link: "https://olesmoky.com/collections/merchandise/products/moonshine-club-tee",
  },
  {
    id: 9,
    label: "BORN TO SHINE HAT",
    imageSrc: slide9Src,
    link: "https://olesmoky.com/collections/merchandise/products/born-to-shine-hat",
  },
  {
    id: 10,
    label: "THIS IS PROBABLY MOONSHINE CANVAS FLASK",
    imageSrc: slide10Src,
    link: "https://olesmoky.com/collections/merchandise/products/this-is-probably-moonshine-canvas-flask",
  },
  {
    id: 11,
    label: "DRINKIN WATERMELON TEE",
    imageSrc: slide11Src,
    link: "https://olesmoky.com/collections/womens-apparel/products/drinkin-watermelon-tee",
  },
];

export const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
